"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.flexDirectionToStackDirection = exports.stackDirectionToFlexDirection = void 0;
var flexbox_1 = require("../components/flexbox");
var stack_1 = require("../components/stack");
var STACK_TO_FLEX_DIRECTION_MAPPING = (_a = {},
    _a[stack_1.StackDirectionType.HORIZONTAL] = flexbox_1.FlexDirectionType.ROW,
    _a[stack_1.StackDirectionType.VERTICAL] = flexbox_1.FlexDirectionType.COLUMN,
    _a);
var FLEX_TO_STACK_DIRECTION_MAPPING = (_b = {},
    _b[flexbox_1.FlexDirectionType.ROW] = stack_1.StackDirectionType.HORIZONTAL,
    _b[flexbox_1.FlexDirectionType.COLUMN] = stack_1.StackDirectionType.VERTICAL,
    _b[flexbox_1.FlexDirectionType.COLUMN_REVERSE] = stack_1.StackDirectionType.VERTICAL,
    _b[flexbox_1.FlexDirectionType.ROW_REVERSE] = stack_1.StackDirectionType.HORIZONTAL,
    _b);
function stackDirectionToFlexDirection(stackDirection) {
    return STACK_TO_FLEX_DIRECTION_MAPPING[stackDirection];
}
exports.stackDirectionToFlexDirection = stackDirectionToFlexDirection;
function flexDirectionToStackDirection(direction) {
    return FLEX_TO_STACK_DIRECTION_MAPPING[direction];
}
exports.flexDirectionToStackDirection = flexDirectionToStackDirection;
//# sourceMappingURL=direction.js.map